import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@mui/material";
import axios from "axios";
import {
  AutoCompleteComponent,
  FormLabel,
  ModalError,
  ModalSuccess,
  PrimaryButton,
  SecondaryButton,
  TextInput,
} from "components";
import { useEffect, useState } from "react";
import { hardBaseUrl } from "services/urlConstant";
import { getErrors } from "utils";

const ModalFormParameterCountry = ({
  open,
  onClose,
  preload,
  optionCurrency,
  getDataTable,
}) => {
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const [loadingButton, setLoadingButton] = useState(false);
  const [payload, setPayload] = useState({
    country_name: "",
    country_iso_code: "",
    currency_id: 0,
  });

  const handleChangePayload = (value, key) => {
    setPayload(currentState => ({
      ...currentState,
      [key]: value,
    }));
  };
  const handleSubmit = async () => {
    const method = preload ? axios.put : axios.post;
    try {
      setLoadingButton(true);
      await method(
        `${hardBaseUrl}/country/${
          preload ? `update/${preload?.id}` : "create"
        }`,
        payload,
        { headers }
      );
      ModalSuccess(
        `Successfully ${preload ? "update" : "create"} country`
      ).then(() => getDataTable());
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingButton(false);
      onClose();
    }
  };

  useEffect(() => {
    if (preload) {
      setPayload({
        country_name: preload?.country_name,
        country_iso_code: preload?.country_iso_code,
        currency_id: preload?.currency?.id,
      });
    }
  }, [preload]);
  return (
    <Dialog fullWidth open={open} onClose={onClose}>
      <DialogTitle>{`${preload ? "Edit" : "Add"} User`}</DialogTitle>
      <DialogContent dividers>
        <Grid container direction="column" rowSpacing={2}>
          <Grid item>
            <FormLabel label="Country Code" required />
            <TextInput
              placeholder="Country Code"
              value={payload?.country_iso_code}
              onChange={e =>
                handleChangePayload(e?.target?.value, "country_iso_code")
              }
              disabled={loadingButton}
            />
          </Grid>
          <Grid item>
            <FormLabel label="Country Name" required />
            <TextInput
              placeholder="Country Name"
              value={payload?.country_name}
              onChange={e =>
                handleChangePayload(e?.target?.value, "country_name")
              }
              disabled={loadingButton}
            />
          </Grid>
          <Grid item>
            <FormLabel label="Currency" required />
            <AutoCompleteComponent
              options={optionCurrency}
              placeholder="Currency"
              value={
                optionCurrency.find(
                  option => option.id === payload?.currency_id
                ) || null
              }
              onChange={value => handleChangePayload(value, "currency_id")}
              width="100%"
              size="small"
              disabled={loadingButton}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <SecondaryButton
          label="Cancel"
          disabled={loadingButton}
          onClick={onClose}
        />
        <PrimaryButton
          label={loadingButton ? "Saving" : "Save"}
          loading={loadingButton}
          disabled={loadingButton}
          onClick={handleSubmit}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ModalFormParameterCountry;
